__turbopack_context__.v({
  "className": "avertalightitalic_7c0e1c3-module__tO45HW__className",
  "variable": "avertalightitalic_7c0e1c3-module__tO45HW__variable",
});
